import { Global, css, useTheme } from "@emotion/react";

const GlobalStyle = () => {
  const theme = useTheme();

  return (
    <Global
      styles={css`
        body {
          background-color: ${theme.black};
          font-size: 1.25rem;
          font-family: "VT323", monospace;
          min-width: 320px;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
        }
        h1 {
          font-family: "Press Start 2P", monospace;
          font-size: 0.75rem;
          color: ${theme.header};
          margin-block-start: 0;
          margin-block-end: 0.5rem;
          ::selection {
            color: ${theme.body};
          }
        }
        p {
          font-size: 1.25rem;
          margin-block-start: 0;
          margin-block-end: 0;
          color: ${theme.body};

          ::selection {
            color: ${theme.header};
          }
        }
      `}
    />
  );
};

export default GlobalStyle;
